import { useRouterState } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { DesktopNav } from "./desktop-nav";
import { HeaderActions } from "./header-actions";
import { MobileMenu } from "./mobile-menu";
import { LocalizedLink } from "#/components/locale/localized-link";
import { TenbaggerLogo } from "#/components/ui/logo.tsx";

const AccountMenu = lazy(() => import("./account-menu"));

export default function Header() {
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (pathname === "/") {
		return null;
	}

	return (
		<header className="sticky top-0 z-50 border-b border-border bg-card px-4">
			<nav className="flex h-[50px] items-center justify-between gap-3 md:gap-6">
				<div className="flex items-center gap-10">
					<LocalizedLink
						to="/"
						className="flex items-center gap-2 text-foreground no-underline"
					>
						<div className="flex items-center gap-2">
							<TenbaggerLogo width={20} height={20} className="size-6 md:size-5" />
							<span className="hidden text-title2 md:inline">
								Tenbagger
							</span>
						</div>
					</LocalizedLink>

					<DesktopNav />
				</div>

				<div className="flex items-center gap-2">
					<Suspense fallback={<div className="h-8 w-20" />}>
						<AccountMenu />
					</Suspense>
					<MobileMenu />
					<HeaderActions />
				</div>
			</nav>
		</header>
	);
}
